/* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import ContactForm from '../forms/ContactForm';

class Contact extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: 'Contact' }]);

        // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { actions, profile } = this.props;

        return (
            <div className="contact-page-wrapper">
                <Helmet title="Contact us" />
                <div className="container">

                    <div className="row">
                        <div className="col-md-5 left-col">
                            <h1>Contact us</h1>
                            <p>Want to get in contact with Clever Tykes directly? Reach out here.</p>
                            <h2>Your stories</h2>
                            <p>Find Clever Tykes on <a href="https://www.facebook.com/CleverTykes" target="_blank" rel="noopener noreferrer">Facebook</a>,&nbsp;
                                <a href="https://twitter.com/clevertykes" target="_blank" rel="noopener noreferrer">Twitter</a> and&nbsp;
                                    <a href="https://www.instagram.com/clevertykes/" target="_blank" rel="noopener noreferrer">Instagram</a>. We’d love to hear your
                                        stories of your school enjoying the resources!</p>

                            <div className="social-icons">
                                <a href="https://twitter.com/clevertykes" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a>
                                <a href="https://www.facebook.com/CleverTykes" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" /></a>
                                <a href="https://www.youtube.com/user/CleverTykes" target="_blank" rel="noopener noreferrer"><i className="fa fa-youtube" /></a>
                                <a href="https://www.instagram.com/clevertykes/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram" /></a>
                            </div>
                        </div>
                        <div className="col-md-1 col-sm-hidden" />
                        <div className="col-md-6 contact-form-wrapper">
                            <ContactForm profile={profile} handleSubmit={actions.contactRequest} />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

Contact.propTypes = {
    actions: PropTypes.object,
    profile: PropTypes.object
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/pages/Contact.js
 **/